import { useSearchParams } from 'react-router-dom';

import { useBroadcaster } from '@frontend/shared/hooks/shared.hook.useBroadcaster';
import { useQuestionList } from '@frontend/shared/hooks/useQuestionList';
import { useQuestionSearch } from '@frontend/shared/hooks/useQuestionSearch';

export function useQuestionFilter() {
  const [search] = useSearchParams();
  const q = search.get('q') ?? '';
  const browseRes = useQuestionList({ condition: !q });
  const searchRes = useQuestionSearch({ query: q });

  // Listen for question updates
  useBroadcaster((e) => {
    let rerender = false;
    if (e.event === 'question:add') {
      if (browseRes.result) {
        browseRes.result.questions = [
          e.question,
          ...browseRes.result.questions,
        ];
        rerender = true;
      }
    }
    if (e.event === 'question:delete') {
      if (browseRes.result) {
        browseRes.result.questions = browseRes.result.questions.filter(
          (q) => e.questionId !== q.id,
        );
        rerender = true;
      }
      if (searchRes.result) {
        searchRes.result.answers = searchRes.result.answers.filter(
          (q) => q.service !== 'questionbase' || e.questionId !== q.id,
        );
        rerender = true;
      }
    }
    if (e.event === 'question:save') {
      if (browseRes.result) {
        browseRes.result.questions = browseRes.result.questions.map((q) =>
          q.id === e.question.id ? e.question : q,
        );
        rerender = true;
      }

      if (searchRes.result) {
        searchRes.result.answers = searchRes.result.answers.map((q) => {
          if (q.service === 'questionbase' && q.id === e.question.id) {
            q.raw_answer = e.question;
          }
          return q;
        });
        rerender = true;
      }
    }

    if (rerender) {
      return 'force-rerender';
    }
  });

  return {
    result: q ? searchRes : browseRes,
    hasFilter: !!q,
  };
}
